// extracted by mini-css-extract-plugin
export default {"containner":"CustomFieldItem_containner__UBZ09","containnerFull":"CustomFieldItem_containnerFull__Iq2Cn"};